var Curriculog = Curriculog || {};
Curriculog.ProposalForm = Curriculog.ProposalForm || {};

Curriculog.ProposalForm.AssessmentField = (function ($, _, Backbone, AssessmentField) {

	// CURRENTLY UNUSED. For times sake, assessments were not moved to the new views.
	AssessmentField = Curriculog.ProposalForm.Field.extend({

		events: {
			'click': 'edit',
			// 'click .fieldset-buttons button.save-field': 'saveItem',
			// 'click .fieldset-buttons button.remove-assessment': 'removeItem',
			'click .fieldset-buttons button.add-assessment-item': 'addItem',
			'click .fieldset-buttons button.save-all': 'save',
			'click .fieldset-buttons button.done-editing': 'saveClose'
		},

		initialize: function(options) {
			Curriculog.ProposalForm.Field.prototype.initialize.call(this, options);
			this.items = [];
		},

		render: function() {
			this.setElement($('.field-' + this.model.id));
			//TODO: this needs to return promises for the rendered items
			this.setItems();
			return $.when(); // then sum them up here
		},

		setItems: function() {
			_.each(this.items, this.unsetItem, this);
			var asses = this.$el.find('fieldset');
			this.items = _.map(asses, this.setItem, this);
		},

		setItem: function(item) {
			var itemView = new Curriculog.ProposalForm.AssessmentFieldItem({
				userPermissions: this.userPermissions,
				proposal: this.proposal,
				section: this.section,
				field: this,
				item: item
			});
			return itemView;
		},

		unsetItem: function(itemView) {
			itemView.destroy();
		},

		// removeItem: function(event) {
		// 	console.log('Backbone:removeItem');
		// 	if (event) {
		// 		event.preventDefault();
		// 		event.stopPropagation();
		// 	}
		// },

		addItem: function(event) {
			console.log('Backbone:addItem');
			if (event) {
				event.preventDefault();
				event.stopPropagation();
			}
			smartfieldObject.loadSmartfieldData(this.$('.add-assessment-item'), true);
		},

		// saveItem: function(event) {
		// 	console.log('Backbone:saveItem');
		// 	if (event) {
		// 		event.preventDefault();
		// 		event.stopPropagation();
		// 	}
		// },

		saveClose: function(event) {
			console.log('Backbone:saveClose');
			if (event) {
				event.preventDefault();
				event.stopPropagation();
			}
		},

		getValue: function() {
			// TODO
		},

		setValue: function(value) {
			// TODO? might not need this for assessments, but I remember seeing
			// conflict resolution for it somewhere.
		},

		afterEdit: function() {
			return $.when(_.map(this.items, function(item) {
				return item.afterEdit();
			}));
		}

	});

	return AssessmentField;

})($, _, Backbone, Curriculog.ProposalForm.AssessmentField || {});